module.exports = __webpack_public_path__ + "static/media/raven.293ab06d.png";